import React from 'react';
import { ValidatedControl } from '../Components/ValidatedControl';
import { TextInput } from '../Components/TextInput';
import { Field } from 'react-final-form';
import { IBaseControlField } from './types';

export const TextInputField = ({ label, name, disabled }: IBaseControlField) => (
    <Field<string> name={name}>
        {({ input, meta }) => (
            <ValidatedControl
                id={name}
                disabled={disabled}
                invalid={(meta.error || meta.submitError) && meta.touched}
                caption={label}
                validationMessage={meta.error}
                variant="SmallColumns"
            >
                {(props) => <TextInput {...props} {...input} />}
            </ValidatedControl>
        )}
    </Field>
);
